import { WorkspaceImage } from "../WorkspaceImage";
import { formatWorkspaceRole } from "../../workspaceDropdown.utils";
import { cn } from "utils/cn";
import { WorkspaceProfileInfoProps } from "./WorkspaceProfileInfo.types";

export const WorkspaceProfileInfo = ({
  workspaceId,
  workspaceName,
  role,
  imagePath,
  className,
  subtitle,
}: WorkspaceProfileInfoProps) => {
  const secondLine = subtitle ?? (role ? formatWorkspaceRole(role) : "Workspace");

  return (
    <div className={cn("flex items-center gap-2 px-1 py-1.5 text-left text-sm", className)}>
      <WorkspaceImage
        workspaceId={workspaceId}
        workspaceName={workspaceName}
        imagePath={imagePath}
        isActive
        size="md"
      />
      <div className="grid min-w-0 flex-1 text-left text-sm leading-tight">
        <span className="truncate font-medium text-foreground">{workspaceName}</span>
        <span className="truncate text-xs text-muted-foreground">{secondLine}</span>
      </div>
    </div>
  );
};
